//@flow
import * as React from 'react';
import ConnectButton from 'app/common/react/components/Nags/CompromisedAccountNag/ConnectButton';
import i18n from 'app/common/lib/i18n';
import { Box, Button, IconButton, Text } from 'gestalt';

type Props = {|
  onChangePassword: () => void,
  onDismiss: () => void,
  onFacebookConnect: () => void,
  onGoogleConnect: () => void,
|};

const NagBanner = ({ onChangePassword, onDismiss, onFacebookConnect, onGoogleConnect }: Props) => (
  <div className="gridCentered">
    <Box marginTop={6} marginEnd={3} marginStart={3} overflow="hidden" shape="rounded">
      <Box color="darkGray" paddingY={4} paddingX={4}>
        <Box display="flex" alignItems="start" justifyContent="between">
          <Box flex="grow">
            <Text color="white" bold>
              {i18n._(
                'Based on our automatic security checks, it looks like your Pinterest password is the same as one that was stolen from another site.',
                'Notify user their account credentials are compromised',
              )}
            </Text>
            <Box marginTop={3}>
              <Text color="white" bold>
                {i18n._(
                  'We recommend you change your password or connect your Google or Facebook account.',
                  'Suggest a user change their password or connect to Google / Facebook',
                )}
              </Text>
            </Box>
          </Box>
          <Box marginTop={-2} marginEnd={-2}>
            <IconButton
              accessibilityLabel={i18n._('Close', 'accessibility close label')}
              onClick={onDismiss}
              icon="cancel"
            />
          </Box>
        </Box>
        <Box xs={{ display: 'flexColumn' }} sm={{ display: 'flex' }} marginTop={4}>
          <Button
            inline
            onClick={onChangePassword}
            text={i18n._('Change Password', 'Shows a form for the user to change their password')}
          />
          <ConnectButton onClick={onGoogleConnect} text={i18n._('Connect with Google')} />
          <ConnectButton onClick={onFacebookConnect} text={i18n._('Connect with Facebook')} />
        </Box>
      </Box>
    </Box>
  </div>
);

export default NagBanner;
